import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Select } from 'components'
import styles from './index.module.css'

const CareerIncomeDetails1 = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: <i className="icon icon_close" />
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding">
					<Select title="월별 납부내역 보기" className="bold auto" style={{ borderBottom: 0, height: "3rem", lineHeight: "3rem" }} selected={1} data={[
						{ key: "2022년 1월", value: 0 },
						{ key: "2022년 2월", value: 1 },
						{ key: "2022년 3월", value: 2 },
					]} onSelect={(key, value) => {
						console.log(key, value)
					}}>
					</Select>
					<div className={`${styles["l-title"]} mt_15`}>보험료 납부금액</div>
					<div className={`${styles["price-lg"]} mt_10`}><strong>501,000</strong> 원</div>
					<div className="date-progress mt_40 pb_30">
						<div className="date">
							<span>0원</span>
							<span>601,000 원</span>
						</div>
						<div className="progress mt_10">
							<span style={{ width: "70%" }} />
						</div>
						<span className="date-guide bubble center" style={{ left: "59%" }}>70% 납부</span>
					</div>
				</div>
			</div>
			<div className="padding">
				<p className={`${styles["tag-txt"]} mt_10`}>#지역가입자</p>
				<div className={`${styles["result-title"]} mt_20`}>
					건강보험 고지금액 <strong style={{ color: "#333" }}>301,000원</strong>이며<br />
					현재 <strong>100%</strong> 납부되었네요!
				</div>
				<ul className={`${styles["bar-horizontal"]} mt_40`}>
					<li>
						<div className={styles.title}><strong className="text-blue">건강보험</strong></div>
						<div className={styles["bar-area"]}>
							<div className={styles.bar}>
								<span style={{ width: "100%", background: "var(--main-color)" }}>
									<span className={styles.percent}>100%</span>
								</span>
							</div>
							<span>301,000원 납부</span>
						</div>
					</li>
					<li>
						<div className={styles.title}>장기요양보험</div>
						<div className={styles["bar-area"]}>
							<div className={styles.bar}>
								<span style={{ width: "100%" }}>
									<span className={styles.percent}>100%</span>
								</span>
							</div>
							<span>400,000원 납부</span>
						</div>
					</li>
				</ul>
			</div>
		</div>
	)
}

export default CareerIncomeDetails1
